// extracted by mini-css-extract-plugin
export default {"enterpriseSettings":"styles_enterpriseSettings__1XK1G","enterpriseTitle":"styles_enterpriseTitle__g5fFN"};